module.exports = __webpack_public_path__ + "tables/media/Profile_filled.6e13f8c5.svg";